import { apiClient } from './client';
import { Storyteller, SourceStory } from '../../types';

export interface CreateStorytellerRequest {
  name: string;
  personality: string;
  style: string;
  isActive?: boolean;
}

export interface UpdateStorytellerRequest extends Partial<CreateStorytellerRequest> {}

export const storytellersApi = {
  getStorytellers: async (storyId: string): Promise<{ data: Storyteller[] }> => {
    return apiClient.get<{ data: Storyteller[] }>(`/api/v1/admin/source-stories/${storyId}/storytellers`);
  },

  createStoryteller: async (storyId: string, data: CreateStorytellerRequest): Promise<{ data: Storyteller }> => {
    return apiClient.post<{ data: Storyteller }>(`/api/v1/admin/source-stories/${storyId}/storytellers`, data);
  },

  updateStoryteller: async (storyId: string, id: string, data: UpdateStorytellerRequest): Promise<{ data: Storyteller }> => {
    return apiClient.put<{ data: Storyteller }>(`/api/v1/admin/source-stories/${storyId}/storytellers/${id}`, data);
  },

  deleteStoryteller: async (storyId: string, id: string): Promise<{ data: {} }> => {
    return apiClient.delete<{ data: {} }>(`/api/v1/admin/source-stories/${storyId}/storytellers/${id}`);
  },

  activateStoryteller: async (storyId: string, id: string): Promise<{ data: { success: true } }> => {
    return apiClient.post<{ data: { success: true } }>(`/api/v1/admin/source-stories/${storyId}/storytellers/${id}/activate`);
  },
};

